import {
  Icon,
  IconColor,
} from '@delmonicos/shared-design-system-react/src/components/icon/icon';
import { Popover } from '@delmonicos/shared-design-system-react/src/components/popover/popover';
import {
  GapEnum,
  Stack,
} from '@delmonicos/shared-design-system-react/src/components/stack/stack';
import { Tag } from '@delmonicos/shared-design-system-react/src/components/tag/tag';
import { TicketPriority } from '@delmonicos/shared-sdk/libs/cpms/src/libs/support-service-lib/src/wrapper/enums/ticket-priority.enum';
import classNames from 'classnames';

import {
  PRIORITY_CONFIG,
  PRIORITY_ORDER,
} from '../priority-tag/priority-tag.helper';
import * as css from './priority-popover.module.scss';

interface PriorityPopoverComponentProps {
  priority: TicketPriority;
  onSelect: (priority: TicketPriority) => void;
}

export const PriorityPopoverComponent = ({
  priority,
  onSelect,
}: PriorityPopoverComponentProps): React.JSX.Element => {
  return (
    <Popover
      align="end"
      contentClassName={css.popoverContent}
      trigger={
        <Tag className={PRIORITY_CONFIG[priority].tagClass} gap={GapEnum.XS}>
          <Icon
            name={PRIORITY_CONFIG[priority].icon}
            color={PRIORITY_CONFIG[priority].iconColor}
          />
          <Icon name="chevron-down" color={IconColor.Secondary} />
        </Tag>
      }>
      {(close) => (
        <Stack direction="column" gap={GapEnum.XXS}>
          {PRIORITY_ORDER.map((option) => {
            const config = PRIORITY_CONFIG[option];

            return (
              <button
                key={option}
                type="button"
                className={classNames(
                  css.priorityOption,
                  option === priority && css.active,
                )}
                onClick={() => {
                  onSelect(option);
                  close();
                }}>
                <Tag className={config.tagClass} gap={GapEnum.XXS}>
                  <Icon name={config.icon} color={config.iconColor} />
                </Tag>
              </button>
            );
          })}
        </Stack>
      )}
    </Popover>
  );
};
